import React, { FC, useEffect } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { createPortal } from 'react-dom';
import { WithTranslation, withTranslation } from 'react-i18next';
import useStickyWrapper from '../../hooks/useStickyWrapper';
import { detectScrollDirectionForNavigationBar } from '../../utils/detectScrollDirectionForNavigationBar';
import { windowService } from '../../utils/window.utils';
import NavigationSection from '../@shared/navigationSection';
import { TNavigationBarProps } from '../@shared/navigationSection/types/navigationBar.types';

const NavigationBar: FC<WithTranslation & TNavigationBarProps> = (props) => {
  let scrollPosition = 0;
  const stickyWrapperEle = useStickyWrapper();

  const detectScrollDirection = () => {
    scrollPosition = detectScrollDirectionForNavigationBar(stickyWrapperEle, scrollPosition);
  };
  useEffect(() => {
    const windowObj = windowService();
    if (windowObj) {
      windowObj?.addEventListener('scroll', detectScrollDirection, false);
      return () => {
        windowObj?.removeEventListener('scroll', detectScrollDirection);
      };
    }
  }, [stickyWrapperEle]); // eslint-disable-line
  
  return (
    <>
      <NavigationSection {...props} isEditorial={true} />
      {stickyWrapperEle &&
        createPortal(
          <NavigationSection {...props} sticky={true} isEditorial={true} />,
          stickyWrapperEle
        )}
    </>
  );
};
export default withTranslation()(withSitecoreContext()(NavigationBar));